import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps, useDispatch} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as auth from './AuthRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux> = (props) => {
  const [showSplash, setShowSplash] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    // BYPASS: siempre muestra la app
    setShowSplash(false)
    // Si quieres simular usuario logueado:
    // dispatch(props.fulfillUser({ idUser: 1, name: 'Dev' } as any))
    // Si quieres simular logout:
    // dispatch(props.logout())
  }, [dispatch, props])

  return showSplash ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
